import React from 'react';
import AgencyData from './Agency';
import { AuthProvider } from './Auth/AuthContext';
import { IncidentProvider } from './Incident/IncidentContext';
import { ArrestProvider } from './Arrest/ArrestContext';
import { NameProvider } from './Name/NameContext';
import { OffenseProvider } from './Offense/OffenseContext';
import { PropertyProvider } from './Property/PropertyContext';
import { VehicleProvider } from './Vehicle/VehicleContext';
import { WarrantProvider } from './Warrant/WarrantContext';
import { SearchProvider } from './Search/SearchContext';
import { NIBRSProvider } from './NIBRS/NIBRSContext';
import { CaseManagementProvider } from './CaseManagement/CaseManagementContext';
import { PropertyRoomProvider } from './PropertyRoom/PropertyRoomContext';

export const AppProviders = ({ children }) => (
  <AuthProvider>
    <IncidentProvider>
      <ArrestProvider>
        <NameProvider>
          <OffenseProvider>
            <PropertyProvider>
              <VehicleProvider>
                <WarrantProvider>
                  <SearchProvider>
                    <NIBRSProvider>
                      <CaseManagementProvider>
                        <AgencyData>
                          <PropertyRoomProvider>{children}</PropertyRoomProvider>
                        </AgencyData>
                      </CaseManagementProvider>
                    </NIBRSProvider>
                  </SearchProvider>
                </WarrantProvider>
              </VehicleProvider>
            </PropertyProvider>
          </OffenseProvider>
        </NameProvider>
      </ArrestProvider>
    </IncidentProvider>
  </AuthProvider>
);

export default AppProviders;
